import { getGraphAnalyticsFetcher } from '@api/fetcher/ambassdor'
import { useQuery } from '@tanstack/react-query'
import { duration } from 'moment'

interface ReturnType {
  data: any
  isLoading: boolean
  error: any
  isFetching: any
}

const useGraphAnalytics = ({
  startDate,
  endDate,
  applyYearlyMetrics,
}: {
  startDate: any
  endDate: any
  applyYearlyMetrics?: boolean
}): ReturnType => {
  const { isLoading, error, data, isFetching } = useQuery(
    [
      'Graph-Analytics',
      {
        startDate: startDate,
        endDate: endDate,
        applyYearlyMetrics: applyYearlyMetrics,
      },
    ],
    getGraphAnalyticsFetcher,

    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!startDate && !!endDate,
    }
  )
  return {
    data: data?.data?.data,
    error,
    isLoading,
    isFetching,
  }
}

export default useGraphAnalytics
